import classNames from "classnames";
import { useNavigate } from "hooks";
import React, { useCallback } from "react";
import { Task } from "store/types";

import "./LinkedObject.styles.scss";

interface Props {
  linkedEntity?: Task["linked_entity"];
  dealId?: number;
  closeDrawer: () => void;
}

export const LinkedObject: React.FC<Props> = ({ linkedEntity, dealId, closeDrawer }) => {
  const navigate = useNavigate();
  const { title, id, type, form_id } = linkedEntity || {};

  const onClick = useCallback(() => {
    if (!dealId || !type || !id) return;
    if (type === "file") {
      navigate({
        route: "dealFile",
        params: {
          deal_id: dealId,
          file_id: id
        }
      });
    }
    if (type === "form") {
      navigate({
        route: "dealForm",
        params: {
          deal_id: dealId,
          form_id: id
        }
      });
    }
    if (type === "note") {
      navigate({
        route: "dealNote",
        params: {
          deal_id: dealId,
          note_id: id
        }
      });
    }
    if (type === "section") {
      navigate({
        route: "dealFolder",
        params: {
          deal_id: dealId,
          folder_id: id
        },
        search: { section: id },
        setQueriesMethod: "add"
      });
    }
    if (type === "question" && form_id) {
      navigate({
        route: "dealForm",
        params: {
          deal_id: dealId,
          form_id: form_id
        },
        search: { section: id },
        setQueriesMethod: "add"
      });
    }
    closeDrawer();
  }, [id, navigate, dealId, type]);

  return (
    <div onClick={onClick} className="task-linked-entity">
      <span className="text">Linked entity :</span>
      <span className={classNames("text", { "text--blue-italic": !!linkedEntity })}>{title || "-"}</span>
    </div>
  );
};
